<template>
  <main class="payment-page" role="main">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-5">
      </div>
      <div class="col-sm-12 col-md-6 col-lg-7 image-section">
        <img
          class="img-fluid"
          src="/assets/images/backgrounds/me-you-activation-image.jpg"
          alt="Acivation-Input-Image"
        >
      </div>
    </div>
  </main>
</template>

<script>
import EventBus from "@/components/shared/event-bus";
import PaymentService from "@/services/payment.service.js";

import store from "@/store";
import { CART_RESET } from "@/store/actions.type";

export default {
  name: "payment-processed",
  data: function() {
    return {
      is_loading: false,
      username: "",
      has_error: false,
      message: "",
      payment_id: null,
      payment: null,
      status: 0,
      action: false,
      is_success: false,
      isForgotPassword: false
    };
  },
  mounted() {
    var self = this;
    self.is_loading = true;
    self.isForgotPassword = false;
    self.payment_id = self.$route.query.payment_id || null;
    self.$log.debug("payment processed", self.$route.query);
    EventBus.$emit("global_loading", { is_loading: true });
    self.displayPaymentResponse();
  },
  methods: {
    displayPaymentResponse() {
      var self = this;
      self.action = false;
      if (self.payment_id != null) {
        self.$log.debug("Payment details request", self.payment_id);
        PaymentService.getPaymentDetails(self.payment_id)
          .then(function({ data }) {
            self.message = data.data.result;
            self.payment = data;
            self.action = self.payment.data.action;
            self.is_success = self.payment.data.status === 1;
            self.status = data.data.status;
            if (data.success && self.status == 1) {
              store.dispatch(CART_RESET);
            }
            self.$log.debug("Payment details response", data);
            EventBus.$emit("global_loading", { is_loading: false });
            self.$router.push({ path: self.status && self.status == 1 ? '/payment/successful' : '/payment/failed', query: { action: self.action, status: self.status, message: self.message } })
          })
          .catch(function(error) {
            EventBus.$emit("global_loading", { is_loading: false });
            self.$log.error("Error requesting payment details", error);
          });
      }
    },
    forgotPasswordChanged() {      
      var self = this;
      self.$log.debug("Handle Forgot Password Changed");
      self.isForgotPassword = !self.isForgotPassword;
    },
  }
};
</script>

<style lang="scss" scoped>
</style>